import { render, staticRenderFns } from "./AuditrecordsModel.vue?vue&type=template&id=3134c081&scoped=true"
import script from "./AuditrecordsModel.vue?vue&type=script&lang=js"
export * from "./AuditrecordsModel.vue?vue&type=script&lang=js"
import style0 from "./AuditrecordsModel.vue?vue&type=style&index=0&id=3134c081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134c081",
  null
  
)

export default component.exports